import React from 'react'
import { string, shape, oneOf } from 'prop-types'
import { isUndefined } from 'lodash'
import axios from 'axios'

import {
  requestCallback,
} from '../lib/helpers'

import {
  useModal,
} from '../hooks'

import Modal from './Modal'

const ActionButtonWithConfirmModal = ({ className, buttonText, buttonColor, actionLink, action, title, message, okLabel, cancelLabel }) => {
  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  const onAction = () => {
    if (!isUndefined(actionLink)) {
      window.location.href = actionLink
    } else if(!isUndefined(action)) {
      requestCallback(axios({
        url: action.url,
        method: action.method,
        ...action
      }))
    }
  }

  return (
    <React.Fragment>
      <a
        className={className}
        onClick={() => {
          modalSet(true)
        }}
      >
        {buttonText}
      </a>

      <Modal
        isActive={modal}
        onToggleModal={() => {
          modalSet(false)
        }}
      >
        <h3 className='Modal__h3'>{title}</h3>
        <div className='Modal__p__wrapper'>
          <p className='Modal__p'>{message}</p>
        </div>

        <div className='Modal__footer Modal__footer--without-border'>
          <a
            className='Button Button--gray-light'
            onClick={() => {
              modalSet(false)
            }}
          >
            {cancelLabel}
          </a>

          <button
            className={`Button Button--${buttonColor}`}
            onClick={onAction}
            ref={$submitButton}
          >
            {okLabel}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

ActionButtonWithConfirmModal.propTypes = {
  className: string,
  buttonText: string,
  buttonColor: oneOf(['blue', 'red']),
  action: shape({
    url: string.isRequired,
    method: string.isRequired,
  }),
  title: string.isRequired,
  message: string.isRequired,
  actionLink: string,
  okLabel: string,
  cancelLabel: string
}

ActionButtonWithConfirmModal.defaultProps = {
  buttonText: 'Remove',
  buttonColor: 'blue',
  okLabel: 'Confirm',
  cancelLabel: 'Cancel',
}

export default ActionButtonWithConfirmModal
